import script from "./FormViewPaymentComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./FormViewPaymentComponent.vue?vue&type=script&setup=true&lang=js"

import "./FormViewPaymentComponent.vue?vue&type=style&index=0&id=a2a490de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a2a490de"]])

export default __exports__